import React, { FormEventHandler, useState } from 'react';

import { Button, DialogActions, DialogContent } from '@mui/material';

import { VARIANT_OF_REFUND_SURCHARGE } from '~/consts/refund';

import { CollectionReason } from '../../types';
import CaseIDAndReasons from '../Common/CaseIDAndReasons';
import { CogsAdjustmentVccBanner } from '../Common/CogsAdjustmentBanner';
import MarkCancelled from '../Common/MarkCancelled';
import { shouldSkipVccForCogsAdjustment } from '../Utils/RefundUtils';

import SelectRefundVariantWithSurcharge from './SelectRefundVariantWithSurcharge';

interface Props {
  reason: CollectionReason;
  onSubmit: FormEventHandler<HTMLFormElement>;
  decrementStep: () => void;
  defaultComment: string;
  currencyCode: string;
  hasSurcharge?: boolean;
  surchargeAmount?: number;
  defaultCaseId: string;
  approvedCogsAdjustmentAmount?: number | null;
  costCurrencyCode?: string;
}

export default function FailedRefundFromPaymentGateways({
  reason,
  onSubmit,
  decrementStep,
  defaultComment,
  currencyCode,
  hasSurcharge = false,
  surchargeAmount,
  defaultCaseId,
  approvedCogsAdjustmentAmount,
  costCurrencyCode,
}: Props) {
  const [variantOfRefund, setVariantOfRefund] = useState<string>();
  const [markCancelled, setMarkCancelled] = useState<string>();
  // Same rule the payload uses
  const showVccBanner = shouldSkipVccForCogsAdjustment(
    { approved_cogs_adjustment_amount: approvedCogsAdjustmentAmount },
    markCancelled,
  );
  return (
    <>
      <DialogContent dividers>
        <form onSubmit={onSubmit} id="failed-refund-form">
          <CaseIDAndReasons reason={reason} defaultComment={defaultComment} defaultCaseId={defaultCaseId} />
          <SelectRefundVariantWithSurcharge
            hasSurcharge={hasSurcharge}
            currencyCode={currencyCode}
            setVariantOfRefund={setVariantOfRefund}
            variantOfRefund={variantOfRefund}
            surchargeAmount={surchargeAmount}
          />
          {showVccBanner && (
            <CogsAdjustmentVccBanner amount={approvedCogsAdjustmentAmount} currencyCode={costCurrencyCode} />
          )}
          {variantOfRefund !== VARIANT_OF_REFUND_SURCHARGE && (
            <MarkCancelled onChange={(_, value: string) => setMarkCancelled(value)} />
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={decrementStep}>Back</Button>
        <Button type="submit" form="failed-refund-form" variant="contained">
          Continue
        </Button>
      </DialogActions>
    </>
  );
}
